export default {
  getDurationFromHoursAndMinutes(hours, minutes) {
    return hours * 60 + minutes;
  },
  getDurationFromTimeString(timeString) {
    const now = new Date();

    const [timePart, modifier] = timeString.split(' ');
    let [hours, minutes] = timePart.split(':').map(Number);

    if (modifier.toLowerCase() === 'pm' && hours !== 12) {
      hours += 12;
    }
    if (modifier.toLowerCase() === 'am' && hours === 12) {
      hours = 0;
    }

    const target = new Date();
    target.setHours(hours, minutes, 0, 0);

    let minutesDuration = Math.ceil((target - now) / 1000 / 60);

    if (minutesDuration < 0) {
      target.setDate(target.getDate() + 1);
      minutesDuration = Math.ceil((target - now) / 1000 / 60);
    }

    return minutesDuration;
  }
};